import { Injectable } from '@angular/core';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomTabService {

  private currentTab: any = null

  private tabSource = new BehaviorSubject(this.currentTab);
  public tabChanges = this.tabSource.asObservable();

  constructor() { }

  handleTabChange(event: NgbNavChangeEvent) {
    this.tabSource.next(event);
  }
}
